"use client";
import { useAppDispatch, useAppSelector } from "../slice/hooks";
import { getActiveUser, logOutUser, logTempToken } from "../slice/auth-slice";
import { AccountInfo } from "./account-info";
import { UpdatePassword } from "./update-password";
// import RenderUserAvatar from "../common/RenderUserAvatar";

import { getLoggedinUser, useAuth, useIpDetails } from "../../lib/util";
import { useHistoryManager } from "../history/useHistoryManager";
import { TransactionHistory } from "./transaction-history";
import { ordersIcon, userIcon2 } from "../../assets";
import { getUrlData } from "../slice/path-slice";
import { useEffect, useState } from "react";

const ProfilePage = ({
  storePath,
  accessPointId,
  organisation,
  parentScrollRef,
  handleLoginSuccess,
}) => {
  const getSubPathFromUrl = () => {
    if (typeof window === "undefined") return null;

    const parts = window.location.pathname
      .toLowerCase()
      .split("/")
      .filter(Boolean);

    const profileIndex = parts.indexOf("profile");
    if (profileIndex === -1) return null;

    return parts[profileIndex + 1] || null;
  };

  const { navigateTo } = useHistoryManager(storePath);
  const urlData = useAppSelector((state) => getUrlData(state));
  const { logUserOut } = useAuth();
  const [subPath, setSubPath] = useState(() => {
    return urlData?.subPath || getSubPathFromUrl() || "account";
  });

  const { loggedInUser } = useAppSelector((state) =>
    getActiveUser(state, getLoggedinUser()),
  );
  const dispatch = useAppDispatch();
  const { data: ipDetails, isSuccess } = useIpDetails();

  const handleLogout = async () => {
    dispatch(logOutUser());
    const geo = isSuccess ? ipDetails : null;
    const { token, tokenExpiryDate } = await logUserOut(geo);
    dispatch(logTempToken({ token, tokenExpiryDate }));
  };
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const handleLoginClick = () => {
    navigateTo("auth");
  };

  const capitalize = (name) =>
    name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : "";

  useEffect(() => {
    if (!urlData) return;
    const { subPath: subPathFromUrlData } = urlData;
    setSubPath(subPathFromUrlData);
  }, [urlData]);

  useEffect(() => {
    window.scrollTo(0, 0); // 👈 Scroll to top when changing section
  }, [subPath]);

  if (!loggedInUser?.user) {
    return (
      <div className="profile-fallback">
        <h2>You must be logged in to view your profile.</h2>
        <button className="profile-login" onClick={handleLoginClick}>
          Login / Sign Up
        </button>
      </div>
    );
  }

  return (
    <div className="profile">
      <div className="profile-nav">
        <div
          onClick={() =>
            navigateTo("profile/account", {
              urlData: { subPath: "account" },
              replace: true,
            })
          }
          className={subPath === "account" ? "active" : ""}
        >
          <span>{userIcon2}</span>
          <p>My Account</p>
        </div>
        <div
          onClick={() =>
            navigateTo(`profile/orders`, {
              urlData: { subPath: "orders" },
              replace: true,
            })
          }
          className={subPath === "orders" ? "active" : ""}
        >
          <span>{ordersIcon}</span>
          <p>My Orders</p>
        </div>
      </div>

      {subPath === "account" && (
        <div className="profile-info">
          {!isChangingPassword ? (
            <AccountInfo
              loggedInUser={loggedInUser}
              setIsChangingPassword={setIsChangingPassword}
              handleLogout={handleLogout}
            />
          ) : (
            <UpdatePassword
              setIsChangingPassword={setIsChangingPassword}
              loggedInUser={loggedInUser}
              ipDetails={ipDetails}
              handleLoginSuccess={handleLoginSuccess}
            />
          )}
        </div>
      )}

      {subPath === "orders" && (
        <TransactionHistory
          accessPointId={accessPointId}
          organisation={organisation}
          storePath={storePath}
          parentScrollRef={parentScrollRef}
        />
      )}
    </div>
  );
};

export default ProfilePage;
